import * as XLSX from 'xlsx';
import type { PurchaseOrderLine } from '../types/venue';
import { fromMinorUnitsOrNull } from './money';

const poNumber = (id: string): string => id.slice(-8).toUpperCase();

const fmtSize = (ml?: number): string => {
  if (!ml) return '';
  return ml >= 1000 ? `${ml / 1000}L` : `${ml}ml`;
};

export function downloadPurchaseOrderExcel(
  poId: string,
  lines: PurchaseOrderLine[],
  supplierName: string,
): void {
  const rows = lines.map(line => ({
    'Supplier Name':       supplierName,
    'Supplier Item Code':  line.supplierItemCode ?? '',
    'Item Name':           line.displayName,
    'Item Size':           fmtSize(line.bottleSize),
    'Item Price':          fromMinorUnitsOrNull(line.unitPrice) ?? '',
    'Quantity Ordered':    line.orderedQty,
  }));

  const ws = XLSX.utils.json_to_sheet(rows);

  // Column widths
  ws['!cols'] = [
    { wch: 28 }, // Supplier Name
    { wch: 22 }, // Supplier Item Code
    { wch: 40 }, // Item Name
    { wch: 12 }, // Item Size
    { wch: 12 }, // Item Price
    { wch: 18 }, // Quantity Ordered
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Purchase Order');

  XLSX.writeFile(wb, `PO-${poId ? poNumber(poId) : 'UNKNOWN'}.xlsx`);
}
